import {
  CompetencyItem,
  LeaderBoardItem,
  LeaderBoardResponse,
  PioneerClubItem,
  ProgressItem,
  StatisticItem,
  TimeSpentItem,
} from "../types/statistics";
import { baseFetch } from "./base";

export const getCertificates = async (): Promise<[]> => {
  try {
    const response = await baseFetch.get("/certificates");
    return response.data;
  } catch (error) {
    console.error("Error fetching certificates:", error);
    throw error;
  }
};

export const getCompetency = async (): Promise<CompetencyItem[]> => {
  try {
    const response = await baseFetch.get("/competency");
    // console.log("Competency response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching competencies:", error);
    throw error;
  }
};

export const getStatisticPerCompetency = async (
  competency: string,
): Promise<StatisticItem[]> => {
  try {
    const response = await baseFetch.get("/statistic_per_competency", {
      params: { competency },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching statistic per competency:", error);
    throw error;
  }
};

export const getBadges = async (): Promise<string[]> => {
  try {
    const response = await baseFetch.get("/badges");
    return response.data;
  } catch (error) {
    console.error("Error fetching badges:", error);
    throw error;
  }
};

export const getTimeSpent = async (): Promise<TimeSpentItem[]> => {
  try {
    const response = await baseFetch.get("/time_spent");
    return response.data;
  } catch (error) {
    console.error("Error fetching time spent:", error);
    throw error;
  }
};

export const getProgressBar = async (): Promise<ProgressItem[]> => {
  try {
    const response = await baseFetch.get("/progress_bar");
    return response.data;
  } catch (error) {
    console.error("Error fetching progress bar:", error);
    throw error;
  }
};

export const getLeadersBoard = async (): Promise<LeaderBoardResponse> => {
  try {
    const response = await baseFetch.get("/leaders_board");
    return response.data;
  } catch (error) {
    console.error("Error fetching leaders board:", error);
    throw error;
  }
};

export const getPioneersClub = async (): Promise<PioneerClubItem[]> => {
  try {
    const response = await baseFetch.get("/pioneers_club");
    return response.data;
  } catch (error) {
    console.error("Error fetching pioneers club:", error);
    throw error;
  }
};
